export default {
  data() {
    return {
      tf: [
        {
          value: true,
          label: 'Si',
        },
        {
          value: false,
          label: 'No',
        },
      ],
      maritalStatusOpt: [
        {
          value: 'Soltero/a',
          label: 'Soltero/a',
        },
        {
          value: 'Casado/',
          label: 'Casado/a',
        },
        {
          value: 'Unión Libre',
          label: 'Unión Libre',
        },
        {
          value: 'Viudo/a',
          label: 'Viudo/a',
        },
        {
          value: 'Otro',
          label: 'Otro',
        },
      ],
      academicDegree: [
        {
          value: 'Sin Escolaridad',
          label: 'Sin Escolaridad',
        },
        {
          value: 'Primaria',
          label: 'Primaria',
        },
        {
          value: 'Secundaria',
          label: 'Secundaria',
        },
        {
          value: 'Preparatoria/Bachillerato o Tecnológico',
          label: 'Preparatoria/Bachillerato o Tecnológico',
        },
        {
          value: 'Licenciatura o Ingeniería',
          label: 'Licenciatura o Ingeniería',
        },
        {
          value: 'Especialidad',
          label: 'Especialidad',
        },
        {
          value: 'Maestría',
          label: 'Maestría',
        },
        {
          value: 'Doctorado',
          label: 'Doctorado',
        },
      ],
      houseCondition: [
        {
          value: 'Propia',
          label: 'Propia',
        },
        {
          value: 'Rentada',
          label: 'Rentada',
        },
        {
          value: 'Prestada',
          label: 'Prestada',
        },
        {
          value: 'Asentamiento',
          label: 'Asentamiento',
        },
        {
          value: 'Compartida',
          label: 'Compartida',
        },
        {
          value: 'Asentamiento Informal',
          label: 'Asentamiento Informal',
        },
      ],
      houseWalls: [
        {
          value: 'Cemento/Block',
          label: 'Cemento/Block',
        },
        {
          value: 'Madera',
          label: 'Madera',
        },
        {
          value: 'Lámina',
          label: 'Lámina',
        },
        {
          value: 'Otro',
          label: 'Otro',
        },
      ],
      houseRoof: [
        {
          value: 'Cemento/Block',
          label: 'Cemento/Block',
        },
        {
          value: 'Madera',
          label: 'Madera',
        },
        {
          value: 'Lámina',
          label: 'Lámina',
        },
        {
          value: 'Otro',
          label: 'Otro',
        },
      ],
      houseFloor: [
        {
          value: 'Tierra',
          label: 'Tierra',
        },
        {
          value: 'Cemento',
          label: 'Cemento',
        },
        {
          value: 'Cerámica',
          label: 'Cerámica',
        },
        {
          value: 'Otro',
          label: 'Otro',
        },
      ],
      evaluationResult: [
        {
          label: 'No califica en Fundación +Luz',
          value: 'No califica en Fundación +Luz',
        },
        {
          label: 'Sí, califica en Fundación +Luz',
          value: 'Sí, califica en Fundación +Luz',
        },
      ],
      programApplied: [
        {
          value: 'Programa con Fundación Cinépolis',
          label: 'Programa con Fundación Cinépolis',
        },
        {
          value: 'Programa con Fundación Nacional Monte de Piedad.',
          label: 'Programa con Fundación Nacional Monte de Piedad.',
        },
        {
          value: 'Programa con junto Seguro Popular',
          label: 'Programa con junto Seguro Popular',
        },
        {
          value: 'Programa gobierno estatal (DIF, H. Ayuntamiento, PAFOSC, etc.)',
          label: 'Programa gobierno estatal (DIF, H. Ayuntamiento, PAFOSC, etc.)',
        },
        {
          value: 'Programa Gobierno Federal',
          label: 'Programa Gobierno Federal',
        },
        {
          value: 'Programa Fundación Lou',
          label: 'Programa Fundación Lou',
        },
        {
          value: 'Otra Fundación',
          label: 'Otra Fundación',
        },
        {
          value: 'Otro Aliado',
          label: 'Otro Aliado',
        },
        {
          value: 'Costo de recuperación',
          label: 'Costo de recuperación',
        },
      ],
      bathroomOpts: [
        {
          value: 'Pozo',
          label: 'Pozo',
        },
        {
          value: 'Fosa Séptica',
          label: 'Fosa Séptica',
        },
        {
          value: 'Regadera',
          label: 'Regadera',
        },
        {
          value: 'W.C.',
          label: 'W.C.',
        },
        {
          value: 'W.C. y pozo',
          label: 'W.C. y pozo',
        },
        {
          value: 'W.C. y Fosa Séptica',
          label: 'W.C. y Fosa Séptica',
        },
      ],
    };
  },
};
